import {Layout} from 'antd';
import React from 'react';
import styles from "./QueryBuilderTemplate.module.scss";
import QBLogo from "./icons/QB-Icon.svg";
import ParentRouteRedirect from "../ParentRouteRedirect";
import {Routes} from "../../pages/routes";
import {QUERY_BUILDER_TAB, QueryBuilderTabs} from "./QueryBuilderTabs";

const { Header } = Layout;

interface QueryBuilderTemplateProps {
    buttons: React.ReactNode[]
    isCohortAnalyser: boolean
    children?: React.ReactNode
    setQueryBuilderTab: (queryBuilderTab: QUERY_BUILDER_TAB) => void,
    isQueryVisualizerTabEnabled: boolean
}

export const QueryBuilderTemplate = ({buttons, children, isCohortAnalyser, setQueryBuilderTab,
                                      isQueryVisualizerTabEnabled}: QueryBuilderTemplateProps) => {
    const lastButton = buttons[buttons.length - 1]
    // @ts-ignore
    buttons[buttons.length - 1] = React.cloneElement(lastButton, {
        // @ts-ignore
        className: `${lastButton.props.className} ${styles.no_right_margin}`
    })
    
    const title = isCohortAnalyser ? "Cohort Analyzer" : "Query Builder"

    let parentRoute = isCohortAnalyser ? Routes.CohortAnalyser : Routes.QueryBuilderV2

    return <Layout className={styles.layout}>
        <Header className={styles.header}>
            <div className={styles.button_container}>
                <div style={{ display: "flex"}}>
                    <ParentRouteRedirect route={parentRoute} isCohortAnalyser={isCohortAnalyser}>
                        <div className={styles.title_container}>
                            <img className={styles.logo} src={QBLogo} alt="query builder logo" />
                            <div className={styles.title}>{title}</div>
                        </div>
                    </ParentRouteRedirect>
                    {setQueryBuilderTab && <>
                        <QueryBuilderTabs currentTab={QUERY_BUILDER_TAB.QUERY_BUILDER}
                                          setQueryBuilderTab={setQueryBuilderTab}
                                          isQueryVisualizerTabEnabled={isQueryVisualizerTabEnabled}
                                          isCohortAnalyser={isCohortAnalyser}
                        />
                    </>}
                </div>
                <div className={styles.buttons}>{buttons}</div>
            </div>
        </Header>
        <Layout className={styles.layout}>
            {children}
        </Layout>
    </Layout>
}